export default __webpack_public_path__ + "static/media/lubbers-logo-yellow.fc79302f.svg";